// src/utils/reportUtils.js
export const getChartOptions = (reportType) => {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: getReportTitle(reportType),
            },
        },
        scales: {
            y: {
                beginAtZero: false,
            }
        }
    };

    // Nastavení osy Y podle typu reportu
    if (reportType === 'uptime') {
        options.scales.y.min = 0;
        options.scales.y.max = 100;
        options.scales.y.title = { display: true, text: 'Dostupnost (%)' };
    } else if (reportType === 'performance') {
        options.scales.y.min = 0;
        options.scales.y.max = 100;
        options.scales.y.title = { display: true, text: 'Performance skóre' };
    } else if (reportType === 'security') {
        options.scales.y.title = { display: true, text: 'Počet bezp. problémů' };
    } else if (reportType === 'seo') {
        options.scales.y.min = 0;
        options.scales.y.max = 100;
        options.scales.y.title = { display: true, text: 'SEO skóre' };
    }

    return options;
};

export const getReportTitle = (reportType, dateRange) => {
    let title = '';

    switch (reportType) {
        case 'uptime':
            title = 'Report dostupnosti webů';
            break;
        case 'performance':
            title = 'Report výkonu webů';
            break;
        case 'security':
            title = 'Report bezpečnostních problémů';
            break;
        case 'seo':
            title = 'Report SEO skóre';
            break;
        default:
            title = 'Report';
    }

    const range = dateRange === '7days' ? 'za poslední týden' :
        dateRange === '30days' ? 'za posledních 30 dní' :
            'za poslední 3 měsíce';

    return `${title} ${range}`;
};